import Base from './Base'
import trace from 'app-core/lib/trace'
/**
 * 登录相关
 */
export default class Login extends Base {
  // 判断当前用户是否登录
  static async isLogin(params) {
    let res = await super.get('isLogin.json', params)
    console.log('isLogin', res)
    return res
  }

  // 登入
  static async in(data) {
    data = data || {}
    trace.log({
      type: 'in-1',
      data: data
    })
    if (window.$jump.env.weixin || window.$jump.env.miniprogram) {
      let wechatType = 'OFFICIAL_ACCOUNT' // 微信枚举
      if (window.$jump.env.miniprogram) {
        wechatType = 'MINI_PROGRAM' // 小程序枚举
      }
      if (localStorage.getItem('openId')) {
        data.openId = localStorage.getItem('openId')
      }
      if (localStorage.getItem('unionId')) {
        data.unionId = localStorage.getItem('unionId')
      }
      data.wechatType = wechatType
    } else if (data.loginType == 'ding' && data.source != 'fosun_ding') {
      // 钉钉环境中,除了复星环境
      let resDD = await this._ddLogin(data)
      return resDD
    }
    if (data.loginType == 'account') {
      // 账号密码输入自动记住/自动登录
      data.chkpersist = 1
    }
    let resSSO = await this.SSOLogin(data)
    console.log(resSSO)
    trace.log({
      type: 'in-2',
      data: data,
      resSSO
    })
    if (resSSO && resSSO.code === '0') {
      window.mconsole && window.mconsole.upYueYing('登录成功', resSSO, 146, 1)
    }
    return resSSO
  }

  // 所有环境登录方法
  static async SSOLogin(data) {
    // data.autologin = data.autologin || 0// 禁止自动登录
    data.service = $ZConfig.getServerUrl()
    if (window.api) {
      data.deviceId = window.api.deviceId
    }
    // 步骤一: 登入passport
    let resPassport = await super.get('/api/pp/passport/jsonp/login2.json', data, {
      baseURL: $ZConfig.getPassportUrl(),
      withCredentials: true,
      timeout: 60000
    })
    console.log('app-common----------------登录中心登录服务器', resPassport)
    trace.log({
      type: 'SSOLogin-1',
      data: data,
      resPassport
    })
    if (resPassport.openId) {
      localStorage.setItem('openId', resPassport.openId)
    }
    if (resPassport.userId) {
      localStorage.setItem('userId', resPassport.userId)
    }
    if (resPassport.code != '0') {
      console.error(resPassport.msg)
      return resPassport
    }
    // 步骤二: 注入应用服务器 jwt不再需要login.json
    if (resPassport.jwt) {
      localStorage.setItem('token', resPassport.jwt)
      localStorage.setItem('refreshToken', resPassport.refreshToken)
      if (window.$flutter) {
        // 调用刷新apptoken;
        // refreshAppToken
        window.$flutter.refreshAppToken({
          jwt: resPassport.jwt,
          refreshToken: resPassport.refreshToken
        })
      }
    }
    let curServerUrl = $ZConfig.getServerUrl()
    // 步骤三: 重新加载配置信息
    let resConfig = await new Promise(function (resolve) {
      $ZConfig.reload(resolve)
    })
    // 服务域名与企业所在的域名不一致，无法提供后续服务
    if (curServerUrl != $ZConfig.getServerUrl()) {
      alert('当前登录用户所在的企业渠道异常，请联系系统管理员')
      return { code: '100010', msg: '该账号所在的企业信息异常' }
    }
    // console.log('config res', resConfig)
    if (resConfig.code != '0') {
      return resConfig
    }
    // 步骤四: 绑定app信息,异步执行，无需等待
    // this.bindAppInfo()
    if (resPassport.privacyAuthorCode != null) {
      return {
        code: '0',
        privacyAuthorCode: resPassport.privacyAuthorCode,
        logOutUrl: resPassport.logOutUrl
      }
    } else {
      return { code: '0' }
    }
  }

  // 绑定app与阿里云关系，用于推送, 延迟绑定获取设备信息id;否则app会被下架;
  static async bindAppInfo() {
    if (window.isBindAppInfo) {
      console.log('=====bindAppInfo 已经绑定过!')
      return
    }
    console.log('=====bindAppInfo')
    // 阿里云消息推送模块
    let alipush = window.api ? window.api.require('aliPush') : null
    let appCode = $ZConfig.getVal('APP_CODE') || '-1'
    if (alipush && appCode) {
      alipush.getDeviceId(function (ret) {
        console.log('getDeviceId', JSON.stringify(ret))
        window.isBindAppInfo = true
        if (ret.status && ret.DeviceId) {
          Login._bindAppInfo(alipush, appCode, ret.DeviceId)
        } else {
          console.error('无法获取设备id信息', ret)
        }
      })
    }
  }

  static async _bindAppInfo(alipush, appCode, deviceId) {
    let res = await super.post('afterLogin.json', {
      appCode,
      appVersion: (window.api && window.api.appVersion) || '-1',
      systemType: window.api && window.api.systemType,
      deviceId,
      deviceName: window.api && window.api.deviceName,
      deviceModel: window.api && window.api.deviceModel
    })
    console.log(
      'afterLogin.json',
      JSON.stringify({
        appCode,
        appVersion: (window.api && window.api.appVersion) || '-1',
        systemType: window.api && window.api.systemType,
        deviceId,
        deviceName: window.api && window.api.deviceName,
        deviceModel: window.api && window.api.deviceModel
      })
    )
    console.log('afterLogin res:', JSON.stringify(res))
    if (res.code == '0' && res.data.userId) {
      console.log('register sys is ok,start bindAccount:', res.data.userId)
      if (typeof window.flutter_inappwebview !== 'undefined') {
        console.log('flutter不需要阿里云bindAccount推送')
        return
      }
      alipush &&
        alipush.bindAccount &&
        alipush.bindAccount({ account: res.data.userId }, function (ret2, err2) {
          if (!ret2.status) {
            alert(JSON.stringify(err2))
          } else {
            console.log('帐号绑定成功：', res.data.userId)
          }
        })
    }
  }

  // 钉钉编码登录
  static async _ddLogin(data) {
    trace.log({
      type: '_ddLogin-1',
      data: data
    })
    if (!window.dd) {
      alert('钉钉环境初始化异常')
      return { code: '101', msg: '钉钉环境初始化异常' }
    }
    // 有钉钉code直接登录
    if (data.code) {
      trace.log({
        type: '_ddLogin-2',
        data: data
      })
      let resSSO = await this.SSOLogin(data)
      return resSSO
    }

    // 在途商户应用编号
    let ddCorpId = sessionStorage.getItem('dd_corpId')
    if (ddCorpId) {
      let that = this
      let resSSO2 = await new Promise(function (resolve) {
        // 钉钉授权登录
        // https://open-doc.dingtalk.com/docs/doc.htm?spm=a219a.7629140.0.0.63424a97AvBE8E&treeId=171&articleId=107553&docType=1
        window.dd.ready(function () {
          window.dd.runtime.permission.requestAuthCode({
            corpId: ddCorpId,
            onSuccess: async function (result) {
              trace.log({
                type: '_ddLogin-3',
                data: data,
                result
              })
              if (result && result.code) {
                data.code = result.code
                let resSSO = await that.SSOLogin(data)
                resolve(resSSO)
              } else {
                resolve({ code: '102', msg: '无法获得钉钉用户编码[1]' })
                alert('无法获得钉钉用户编码[1],请联系管理员')
              }
            },
            onFail: function (err) {
              // alert('无法获得钉钉用户编码[2],请联系管理员');
              alert('onFail:' + JSON.stringify(err))
              resolve({ code: '103', msg: JSON.stringify(err) })
            }
          })
        })
        window.dd.error(function (err) {
          alert('dd error: ' + JSON.stringify(err))
          resolve({ code: '104', msg: JSON.stringify(err) })
        })
      })
      return resSSO2
    } else {
      // 获取dd_corpId
      let resDing = await super.get('getDingCorpId.json', {
        dd_corp: data.corp
      })
      trace.log({
        type: '_ddLogin-4',
        data: data,
        resDing
      })
      if (resDing.code == '0' && resDing.data) {
        sessionStorage.setItem('dd_corpId', resDing.data)
        let resAgain = await this._ddLogin(data)
        return resAgain
      } else {
        alert('无法找到钉钉商户信息,请联系管理员[003]' + data.corp)
        return { code: '-103', msg: '无法找到钉钉商户信息,请联系管理员[003]' }
      }
    }
  }

  // 切换用户
  static async switchUser(userId) {
    let params = { userId }
    if (window.api) {
      params.chkpersist = 1
    }

    if (window.$jump.env.weixin || window.$jump.env.miniprogram) {
      let wechatType = 'OFFICIAL_ACCOUNT' // 微信枚举
      if (window.$jump.env.miniprogram) {
        wechatType = 'MINI_PROGRAM' // 小程序枚举
      }
      if (localStorage.getItem('openId')) {
        params.openId = localStorage.getItem('openId')
      }
      if (localStorage.getItem('unionId')) {
        params.unionId = localStorage.getItem('unionId')
      }
      params.wechatType = wechatType
    }
    let rs = await super.get('specialLogin.json', params)
    if (rs.code != '0') {
      return rs
    }
    let data = rs.data
    // 先退出
    if (data.logoutUrl) {
      data.logoutUrl.split(',').forEach((url) => {
        new Image().src = url
      })
    }
    let resSSO = await this.SSOLogin({ alp: data.alp, loginType: 'alp' })
    console.log('====================resSSO', resSSO)
    return resSSO
  }

  // 标记消息已读
  static async readMessage(msgId) {
    let data = await super.get(`/notify/${msgId}/readed`)
    if (data.code == '0' && window.api) {
      window.api.setAppIconBadge({
        badge: data.data || 0
      })
    }
    return data
  }

  // 删除消息,id并非msgId
  static async deleteMessage(msgId) {
    let data = await super.get(`/notify/${msgId}/delete`)
    if (data.code == '0' && window.api) {
      window.api.setAppIconBadge({
        badge: data.data || 0
      })
    }
    return data
  }
}
